<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/close/black</title>
    <g id="atoms/icons/24x24/close/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M5.85847763,4.92893219 L11.7977922,10.8686176 L17.7378716,4.92893219 C18.050291,4.61651275 18.556823,4.61651275 18.8692424,4.92893219 C19.1816618,5.24135162 19.1816618,5.7478836 18.8692424,6.06030304 L12.9287922,11.9996176 L18.8692424,17.939697 C19.1816618,18.2521164 19.1816618,18.7586484 18.8692424,19.0710678 C18.556823,19.3834872 18.050291,19.3834872 17.7378716,19.0710678 L11.7977922,13.1306176 L5.85847763,19.0710678 C5.5460582,19.3834872 5.03952621,19.3834872 4.72710678,19.0710678 C4.41468735,18.7586484 4.41468735,18.2521164 4.72710678,17.939697 L10.6667922,11.9996176 L4.72710678,6.06030304 C4.41468735,5.7478836 4.41468735,5.24135162 4.72710678,4.92893219 C5.03952621,4.61651275 5.5460582,4.61651275 5.85847763,4.92893219 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
